<wbo-multi-select-control [valueField]="valueField"
                          [labelField]="labelField"
                          [placeholder]="placeholder"
                          [(value)]="value.categoryId"
                          [sourceSearchModel]="model"
                          [data]="data"
                          [label]="label"
                          (onSelect)="onSelect.emit($event)"
                          [extendedSearchComponent]="extendedSearchComponent"
                          [attr.id]="elementId"
                          (valueChange)="onValueChange($event)">
    <fui-checkbox-control [value]="value.excludeSub" (valueChange)="onExcludeSubChanged($event)"
                                     label="wbo.category.label.exclude-sub-category"></fui-checkbox-control>
</wbo-multi-select-control>
